module.exports = __webpack_public_path__ + "img/baoxiaomi-mouse.89e8fcd7.png";